let leafletStylesPromise: Promise<void> | null = null

/**
 * Charge les feuilles Leaflet une seule fois (pages avec carte uniquement).
 * @returns {Promise<void>} Résolu quand les CSS sont injectées.
 */
export function loadLeafletStyles(): Promise<void> {
  if (!import.meta.client) return Promise.resolve()
  if (!leafletStylesPromise) {
    leafletStylesPromise = Promise.all([
      import('leaflet/dist/leaflet.css'),
      import('leaflet.markercluster/dist/MarkerCluster.css'),
      import('leaflet.markercluster/dist/MarkerCluster.Default.css'),
    ]).then(() => undefined)
  }
  return leafletStylesPromise
}
